import { Popover as MuiPopover } from '@mui/material';
import { Icon } from 'components';
import React, { memo, ReactComponentElement, ReactNode, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styles from './styles';

interface Option extends Styles.ItemPressProps {
  label: string | ReactComponentElement<any>;
  onClick?: () => void;
  disabled?: boolean;
}

interface PopOverProps {
  options: Option[];
  id?: string;
  children?: ReactNode;
}

function BasePopOver(props: PopOverProps) {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const isOpen = Boolean(anchorEl);

  const listdisabledOption = useMemo(
    () =>
      props.options.map(value => (typeof value.disabled === 'boolean' ? value.disabled : false)),
    [props.options],
  );

  const isDisabled = listdisabledOption.length > 0 && !listdisabledOption.includes(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderOptions = props.options.map(
    (option, index) =>
      !option.disabled && (
        <Styles.Item key={index}>
          <Styles.ItemPress
            variante={option.variante}
            onClick={() => {
              option.onClick?.();
              handleClose();
            }}
          >
            {typeof option.label === 'string' ? t(option.label) : option.label}
          </Styles.ItemPress>
        </Styles.Item>
      ),
  );

  const children = props.children || (
    <Icon name="moreVert" color={isOpen ? 'primary' : 'text500'} size={1.4} />
  );

  const toggle =
    typeof props.children === 'string' ? (
      <Styles.Toggle aria-describedby={props.id} onClick={handleClick}>
        {children}
      </Styles.Toggle>
    ) : (
      <Styles.ToggleIcon aria-describedby={props.id} onClick={handleClick}>
        {children}
      </Styles.ToggleIcon>
    );

  if (isDisabled) return null;

  return (
    <Styles.Container onClick={event => event.stopPropagation()}>
      {toggle}
      <MuiPopover
        id={props.id}
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {renderOptions}
      </MuiPopover>
    </Styles.Container>
  );
}

export const Popover = memo(BasePopOver);
